import { render, staticRenderFns } from "./IntakePage.vue?vue&type=template&id=fd4acac8"
import script from "./IntakePage.vue?vue&type=script&lang=js"
export * from "./IntakePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports